import type { MultipleRadioOption } from '../../components'
import { ShipmentService as ShipmentServiceEnum } from '../../interfaces/Services/ServicesEnum'

export { ShipmentServiceEnum as ShipmentService }

export enum ShipmentStatus {
  DRAFT = 5,
  ACTIVE = 1,
  ANNULLED = 3,
  REPLACED = 55,
  DELIVERED = 30,
}

export enum DeliveryType {
  AT_HOME = 20,
  AT_OFFICE = 10,
  INTERNATIONAL = 11,
}

export enum PaymentMode {
  CONTADO = 1,
  COD = 2,
  CREDIT = 3,
  BOXOFFICE_CREDIT = 4,
  DEST_BOXOFFICE_CREDIT = 5,
  EXEMPT = 6,
}

const shipmentStatusLabels: Record<ShipmentStatus, string> = {
  [ShipmentStatus.DRAFT]: 'En Creación',
  [ShipmentStatus.ACTIVE]: 'Activo',
  [ShipmentStatus.DELIVERED]: 'Entregado',
  [ShipmentStatus.ANNULLED]: 'Anulado',
  [ShipmentStatus.REPLACED]: 'Sustituido',
}

const deliveryTypeLabels: Record<DeliveryType, string> = {
  [DeliveryType.AT_HOME]: 'A domicilio',
  [DeliveryType.AT_OFFICE]: 'En oficina',
  [DeliveryType.INTERNATIONAL]: 'Internacional',
}

const paymentModeLabels: Record<PaymentMode, string> = {
  [PaymentMode.CONTADO]: 'Contado',
  [PaymentMode.COD]: 'COD',
  [PaymentMode.CREDIT]: 'Crédito Corporativo',
  [PaymentMode.BOXOFFICE_CREDIT]: 'Crédito taquilla origen',
  [PaymentMode.DEST_BOXOFFICE_CREDIT]: 'Crédito taquilla destino',
  [PaymentMode.EXEMPT]: 'Exento',
}

const shipmentServiceLabels: Record<ShipmentServiceEnum, string> = {
  [ShipmentServiceEnum.STANDARD]: 'Estándar',
  [ShipmentServiceEnum.DOCUMENT]: 'Sobre',
  [ShipmentServiceEnum.DOCUMENT_INTERNATIONAL]: 'Exp. Sobre',
  [ShipmentServiceEnum.STANDARD_INTERNATIONAL]: 'Exp. Estándar',
  [ShipmentServiceEnum.ECONOMIC]: 'Económico',
  [ShipmentServiceEnum.SAVER]: 'Saver',
  [ShipmentServiceEnum.NATIONAL_LOCKER]: 'Casillero nacional',
  [ShipmentServiceEnum.INTERNAL_MAIL]: 'Correspondencia interna',
}

export const shipmentStatusFormat = (status: ShipmentStatus) =>
  shipmentStatusLabels[status]
export const deliveryTypeFormat = (type: DeliveryType) =>
  deliveryTypeLabels[type]
export const paymentModeFormat = (mode: PaymentMode) => paymentModeLabels[mode]
export const shipmentServiceFormat = (service: ShipmentServiceEnum) =>
  shipmentServiceLabels[service]

export const SHIPMENT_STATUS_VALUES = [
  ShipmentStatus.DRAFT,
  ShipmentStatus.ACTIVE,
  ShipmentStatus.DELIVERED,
  ShipmentStatus.ANNULLED,
  ShipmentStatus.REPLACED,
] as const

export const DELIVERY_TYPE_VALUES = [
  DeliveryType.AT_HOME,
  DeliveryType.AT_OFFICE,
  DeliveryType.INTERNATIONAL,
] as const

export const PAYMENT_MODE_VALUES = [
  PaymentMode.COD,
  PaymentMode.CONTADO,
  PaymentMode.CREDIT,
] as const

export const SHIPMENT_SERVICE_VALUES = [
  ShipmentServiceEnum.STANDARD,
  ShipmentServiceEnum.DOCUMENT,
  ShipmentServiceEnum.ECONOMIC,
  ShipmentServiceEnum.STANDARD_INTERNATIONAL,
  ShipmentServiceEnum.DOCUMENT_INTERNATIONAL,
  ShipmentServiceEnum.NATIONAL_LOCKER,
] as const

export const INITIAL_STATUSES: MultipleRadioOption<ShipmentStatus>[] =
  SHIPMENT_STATUS_VALUES.map((status) => ({
    name: shipmentStatusFormat(status),
    value: status,
    checked: false,
  }))

export const INITIAL_DELIVERY_TYPES: MultipleRadioOption<DeliveryType>[] =
  DELIVERY_TYPE_VALUES.map((type) => ({
    name: deliveryTypeFormat(type),
    value: type,
    checked: false,
  }))

export const INITIAL_PAYMENT_MODES: MultipleRadioOption<PaymentMode>[] =
  PAYMENT_MODE_VALUES.map((mode) => ({
    name: paymentModeFormat(mode),
    value: mode,
    checked: false,
  }))

export const INITIAL_SERVICES: MultipleRadioOption<ShipmentServiceEnum>[] =
  SHIPMENT_SERVICE_VALUES.map((service) => ({
    name: shipmentServiceFormat(service),
    value: service,
    checked: false,
  }))
